import { useEffect, useRef, useState } from "react";
import { Link } from "react-router-dom";
import AffichListFilms from "./AffichListFilms";
import FormTexte from "./FormTexte";
import "./AffichListFilms.css";

export default function Films() {
  const [critere, setCritere] = useState("");
  const [heroFilm, setHeroFilm] = useState(null);
  const [popular, setPopular] = useState([]);
  const [monthlyTop, setMonthlyTop] = useState([]);
  const [classicTop, setClassicTop] = useState([]);
  const [upcoming, setUpcoming] = useState([]);
  const searchResultsRef = useRef(null);

  let handlerCritere = (v) => setCritere(v);

  useEffect(() => {
    const apiKey = "9b2511a35c2a1b656502230e8819a81c";
    const fetchList = async (endpoint, setter) => {
      try {
        const response = await fetch(
          `https://api.themoviedb.org/3/${endpoint}?api_key=${apiKey}&language=fr-FR&page=1`
        );
        const data = await response.json();
        const filtered = (data.results || []).filter((film) => film.poster_path);
        setter(filtered);
        return filtered;
      } catch (error) {
        console.log(error);
        return [];
      }
    };

    const formatDate = (date) => date.toISOString().slice(0, 10);
    const addMonths = (date, months) => {
      const copy = new Date(date);
      copy.setMonth(copy.getMonth() + months);
      return copy;
    };
    const fetchUpcomingDiscover = async () => {
      try {
        const today = new Date();
        today.setHours(0, 0, 0, 0);
        const endDate = addMonths(today, 12);
        const collected = new Map();
        for (let page = 1; page <= 3; page += 1) {
          const params = new URLSearchParams({
            api_key: apiKey,
            language: "fr-FR",
            sort_by: "primary_release_date.asc",
            include_adult: "false",
            "primary_release_date.gte": formatDate(today),
            "primary_release_date.lte": formatDate(endDate),
            page: String(page),
          });
          const response = await fetch(
            `https://api.themoviedb.org/3/discover/movie?${params.toString()}`
          );
          const data = await response.json();
          (data.results || []).forEach((film) => {
            if (film.poster_path) {
              collected.set(film.id, film);
            }
          });
        }
        setUpcoming(Array.from(collected.values()));
      } catch (error) {
        console.log(error);
        setUpcoming([]);
      }
    };

    const fetchMonthlyTop = async () => {
      try {
        const today = new Date();
        const monthStart = new Date(today.getFullYear(), today.getMonth(), 1);
        const monthEnd = new Date(today.getFullYear(), today.getMonth() + 1, 0);
        const params = new URLSearchParams({
          api_key: apiKey,
          language: "fr-FR",
          sort_by: "popularity.desc",
          include_adult: "false",
          "primary_release_date.gte": formatDate(monthStart),
          "primary_release_date.lte": formatDate(monthEnd),
          page: "1",
        });
        const response = await fetch(
          `https://api.themoviedb.org/3/discover/movie?${params.toString()}`
        );
        const data = await response.json();
        const filtered = (data.results || []).filter((film) => film.poster_path);
        setMonthlyTop(filtered.slice(0, 10));
      } catch (error) {
        console.log(error);
        setMonthlyTop([]);
      }
    };

    const fetchClassicTop = async () => {
      try {
        const today = new Date();
        const cutoff = new Date(today.getFullYear() - 10, today.getMonth(), today.getDate());
        const params = new URLSearchParams({
          api_key: apiKey,
          language: "fr-FR",
          sort_by: "vote_average.desc",
          include_adult: "false",
          "primary_release_date.lte": formatDate(cutoff),
          "vote_count.gte": "500",
          page: "1",
        });
        const response = await fetch(
          `https://api.themoviedb.org/3/discover/movie?${params.toString()}`
        );
        const data = await response.json();
        const filtered = (data.results || []).filter((film) => film.poster_path);
        setClassicTop(filtered.slice(0, 10));
      } catch (error) {
        console.log(error);
        setClassicTop([]);
      }
    };

    fetchList("movie/popular", (data) => {
      setPopular(data);
      if (data.length) {
        setHeroFilm(data[Math.floor(Math.random() * data.length)]);
      }
    });
    fetchMonthlyTop();
    fetchClassicTop();
    fetchUpcomingDiscover();
  }, []);

  useEffect(() => {
    if (critere && searchResultsRef.current) {
      searchResultsRef.current.scrollIntoView({ behavior: "smooth", block: "start" });
    }
  }, [critere]);

  const getReleaseTime = (film) => {
    if (!film.release_date) return Number.POSITIVE_INFINITY;
    const time = new Date(film.release_date).getTime();
    return Number.isNaN(time) ? Number.POSITIVE_INFINITY : time;
  };

  const renderRow = (title, list, anchor) => {
    if (!list.length) return null;
    const formatReleaseDate = (dateString) => {
      if (!dateString) return null;
      const date = new Date(dateString);
      if (Number.isNaN(date.getTime())) return null;
      return date.toLocaleDateString("fr-FR", {
        day: "numeric",
        month: "long",
        year: "numeric",
      });
    };
    return (
      <section className="film-row" id={anchor}>
        <div className="row-header">
          <h3>{title}</h3>
        </div>
        <div className="row-scroll">
          {list.map((film) => (
            <Link className="film-card" to={`/detail/${film.id}`} key={film.id}>
              <img
                src={`https://image.tmdb.org/t/p/w500/${film.poster_path}`}
                alt={film.title}
                loading="lazy"
              />
              <div className="film-card-info">
                <h4>{film.title}</h4>
                <p>
                  {formatReleaseDate(film.release_date)
                    ? `Sorti le ${formatReleaseDate(film.release_date)}`
                    : "Date inconnue"}
                </p>
              </div>
            </Link>
          ))}
        </div>
      </section>
    );
  };

  return (
    <div className="films-page">
      <section className="hero">
        <div className="hero-copy">
          <span className="hero-eyebrow">Plateforme cinéma</span>
          <h1>Des films à découvrir, pas juste une recherche.</h1>
          <p>
            Explore les tendances, les incontournables et les nouveautés.
            Lance-toi et trouve ton prochain coup de cœur.
          </p>
          <div id="search-bar" className="hero-search">
            <FormTexte handler={handlerCritere} />
          </div>
        </div>
        {heroFilm && (
          <div
            className="hero-card"
            style={{
              backgroundImage: `url(${
                heroFilm.backdrop_path
                  ? `https://image.tmdb.org/t/p/original/${heroFilm.backdrop_path}`
                  : `https://image.tmdb.org/t/p/w780/${heroFilm.poster_path}`
              })`,
            }}
          >
            <div className="hero-card-overlay">
              <span>À la une</span>
              <h2>{heroFilm.title}</h2>
              <p>{heroFilm.overview || "Film sélectionné pour vous."}</p>
              <Link className="hero-cta" to={`/detail/${heroFilm.id}`}>
                Regarder la fiche
              </Link>
            </div>
          </div>
        )}
      </section>

      <section className="section-lead">
        <div>
          <h2>Ce qu’il faut voir maintenant</h2>
          <p>Des sélections pensées pour un scroll rapide et efficace.</p>
        </div>
      </section>

      {renderRow("Tendances", popular, "tendances")}
      {renderRow("Top 10 du mois", monthlyTop, "top10")}
      {renderRow("Classiques incontournables", classicTop, "anciens")}
      {renderRow(
        "Prochaines sorties",
        [...upcoming].sort((a, b) => getReleaseTime(a) - getReleaseTime(b)).slice(0, 10),
        "sorties-bientot"
      )}

      {critere && (
        <section className="search-results" id="search-results" ref={searchResultsRef}>
          <AffichListFilms pcritere={critere} />
        </section>
      )}
    </div>
  );
}
